import React, { useState, useEffect } from "react";
import Api from "../../components/api/Api";
import { Col, Container, Row } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const AddAssociatePartner = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  const addPartnerApi = Api({
    url: `admin/associate/partner/add`,
  });

  const getCategoryApi = Api({
    url: "admin/associate/partner/categories",
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const responseData = await getCategoryApi.fetchData(1);
        let fetchedData = [];
        if (responseData && responseData.data) {
          if (responseData.data.associatePartnerCategories) {
            fetchedData = responseData.data.associatePartnerCategories;
          } else if (responseData.data.associatePartnerCategory) {
            fetchedData = Array.isArray(responseData.data.associatePartnerCategory) ? responseData.data.associatePartnerCategory : [responseData.data.associatePartnerCategory];
          } else if (Array.isArray(responseData.data)) {
            fetchedData = responseData.data;
          }
        }
        setCategories(fetchedData.filter(cat => cat.active)); // Only active categories
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    name: "",
    categoryId: "",
    phone_number: "",
    city: "",
    state: "",
    email_address: "",
    website: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);

      const data = {
        name: values.name,
        category: {
          id: Number(values.categoryId)
        },
        phone_number: values.phone_number,
        city: values.city,
        state: values.state,
        email_address: values.email_address,
        website: values.website
      };

      const response = await addPartnerApi.postData(data);
      if (response && response.data && response.data.statusType === "SUCCESS") {
        showToast("Associate Partner added successfully", { type: "success" });
        setTimeout(() => {
          navigate("/associate-partners");
        }, 3000);
      } else {
        showToast(response?.data?.text || "Failed to add partner", { type: "error" });
      }
    } catch (error) {
      console.error(error);
      showToast("Error Occurred", { type: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Partner Network", link: "/partners" },
    { label: "Associate Partners", link: "/associate-partners" },
    { label: "Add Associate Partner", link: "", active: true },
  ];

  return (
    <>
      <Notification />
      <Container fluid style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
        <BreadCrumb items={breadcrumbItems} />
        <Row>
          <Col lg={12} md={12} sm={12}>
            <SingleDetailHeader
              header="Add Associate Partner"
              description="Add a new associate partner here."
            />
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
              {({ isSubmitting }) => (
                <Form>
                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">Name</label>
                        <Field type="text" className="form-control" id="name" placeholder="Enter partner name" name="name" required />
                        <ErrorMessage name="name" component="div" className="text-danger" />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label htmlFor="categoryId" className="form-label">Category</label>
                        <Field as="select" className="form-control form-select" id="categoryId" name="categoryId" required>
                          <option value="">Select Category</option>
                          {categories.map((cat) => (
                            <option key={cat.id} value={cat.id}>
                              {cat.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage name="categoryId" component="div" className="text-danger" />
                      </div>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label htmlFor="phone_number" className="form-label">Phone Number</label>
                        <Field type="text" className="form-control" id="phone_number" placeholder="Enter phone number" name="phone_number" required />
                        <ErrorMessage name="phone_number" component="div" className="text-danger" />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label htmlFor="email_address" className="form-label">Email Address</label>
                        <Field type="email" className="form-control" id="email_address" placeholder="Enter email address" name="email_address" required />
                        <ErrorMessage name="email_address" component="div" className="text-danger" />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <div className="mb-3">
                        <label htmlFor="city" className="form-label">City</label>
                        <Field type="text" className="form-control" id="city" placeholder="Enter city" name="city" required />
                        <ErrorMessage name="city" component="div" className="text-danger" />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3">
                        <label htmlFor="state" className="form-label">State</label>
                        <Field type="text" className="form-control" id="state" placeholder="Enter state" name="state" required />
                        <ErrorMessage name="state" component="div" className="text-danger" />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <label htmlFor="website" className="form-label">Website</label>
                        <Field type="url" className="form-control" id="website" placeholder="https://example.com" name="website" required />
                        <ErrorMessage name="website" component="div" className="text-danger" />
                      </div>
                    </Col>
                  </Row>

                  <button type="submit" className="btn btn-primary mt-4" style={{ marginBottom: "10rem" }} disabled={isSubmitting}>
                    {isSubmitting ? <Spinner loading={true} /> : "Add Associate Partner"}
                  </button>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddAssociatePartner;
